import _ from 'lodash';
import nxModule from 'nxModule';

import reportTypeMapping from './reportTypeMapping';
import templateUrl from './report-list.template.html';
import {setBreadcrumbs} from '../../shared/utils/set-breadcrumbs';
import { canPrintDynamicSoa } from './reportingToolUtils';
import systemPropertyService from '../../../react/system/systemPropertyService';

class ReportList {
  constructor($routeParams, http, breadcrumbs, notification, customerCache) {
    this.$routeParams = $routeParams;
    this.http = http;
    this.breadcrumbs = breadcrumbs;
    this.notification = notification;
    this.customerCache = customerCache;

    // helper to load profile when customerId is present
    this.loadProfile = async () => {
      if (!this.customerId) {
        this.profile = null;
        return;
      }
      try {
        this.profile = await this.customerCache.profile(this.customerId, true, true).toPromise();
      } catch (err) {
        this.profile = null;
        log.error('Error loading customer profile', err);
      }
    };
  }

  async $onInit() {
    if (!this.reportType) {
      this.reportType = _.get(this.$routeParams, 'reportType');
    }

    this.customerId = _.get(this.$routeParams, 'customerId');
    // load profile if customerId exists
    await this.loadProfile();

    const reportMappingEntry = reportTypeMapping[this.reportType];
    this.reportTypeName = reportMappingEntry ? reportMappingEntry.label : '';
    this.title = this.reportTypeName;

    setBreadcrumbs(this.breadcrumbs, 'report-list', this.reportTypeName);

    const reports = await this.http.get('/reports/descriptors').toPromise();
    this.reports = _(reports)
      .filter(report => {
        return reportMappingEntry && report.type === reportMappingEntry.type
      })
      .filter(report => report.visible)
      .filter(report => {
        if (report.code === 'TransactionHistoryDynamicReport' && this.profile) {
          return canPrintDynamicSoa(this.profile.customerNumber, systemPropertyService);
        }
        return true;
      })
      .sortBy(report => report.name)
      .value();
  };

  openLink(report) {
    // if customerId is present in the route then these reports are of CUSTOMER_STATEMENTS type
    if (this.customerId) {
      if (report.fromReportingTool) {
        return `#!/customer/${this.customerId}/statements/view/${report.code}`;
      }
      return `#!/customer/${this.customerId}/statements/${report.code}`;
    }

    return `#!/report/${this.reportType}/reports/${report.code}`;
  }
}

nxModule.component('reportList', {
  templateUrl,
  controller: ReportList,
  bindings: {
    reportType: '<'
  }
});